import { useState, FormEvent } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });

    try {
      await fetch("https://readdy.ai/api/form/d6tivgkj8d20juc904p0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white font-['Montserrat',sans-serif]">
      <Navbar />

      {/* Hero Section */}
      <section className="relative w-full h-[460px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/79e3df398e8a622e13a0466c02d6351b.jpg"
          alt="Mastro Minds Contact Hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-5xl font-light text-white tracking-widest drop-shadow-md">
            Contact
          </h1>
        </div>
      </section>

      {/* Contact Form */}
      <main className="flex-1 w-full">
        <div className="max-w-4xl mx-auto px-8 py-16">
          <p className="text-gray-700 text-base leading-relaxed mb-10">
            Have a question or want to get in touch? Fill out the form below and we&apos;ll get back to you.
          </p>

          <hr className="border-gray-300 mb-10" />

          {submitted ? (
            <div className="py-12 text-center">
              <p className="text-gray-800 text-lg font-medium tracking-wide">
                Thank you for reaching out!
              </p>
              <p className="text-gray-500 text-sm mt-2">
                We&apos;ll be in touch with you soon.
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              id="contact-form"
              className="space-y-6 max-w-xl"
            >
              <div>
                <label className="block text-xs font-semibold tracking-widest text-gray-600 uppercase mb-2">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your name"
                  className="w-full border border-gray-300 px-4 py-3 text-sm text-gray-800 outline-none focus:border-gray-600 transition-colors bg-white"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold tracking-widest text-gray-600 uppercase mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="Your email address"
                  className="w-full border border-gray-300 px-4 py-3 text-sm text-gray-800 outline-none focus:border-gray-600 transition-colors bg-white"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold tracking-widest text-gray-600 uppercase mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  required
                  rows={6}
                  maxLength={500}
                  placeholder="Your message (max 500 characters)"
                  className="w-full border border-gray-300 px-4 py-3 text-sm text-gray-800 outline-none focus:border-gray-600 transition-colors bg-white resize-none"
                />
              </div>
              <div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-gray-900 text-white text-sm font-semibold tracking-widest px-10 py-3 hover:bg-gray-700 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {submitting ? "SENDING..." : "SEND"}
                </button>
              </div>
            </form>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}
